import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { OneEmptyState } from '@factorialco/factorial-one-react/dist/experimental'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {}

const EmptyState = ({}: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (
    <Box flexGrow>
      <OneEmptyState
        title={i18n.t('space_control.overview.no_map_configured')}
        description=""
        emoji={'🗺️'}
        actions={[
          {
            label: i18n.t('space_control.overview.go_to_settings'),
            onClick: () => navigate(navigation.settings.locations.fullPath()),
            type: 'default',
            variant: 'outline',
          },
        ]}
      />
    </Box>
  )
}

export default observer(EmptyState)
